import { render, staticRenderFns } from "./MedicalDateField.vue?vue&type=template&id=ec57af0e&scoped=true"
import script from "./MedicalDateField.vue?vue&type=script&lang=ts"
export * from "./MedicalDateField.vue?vue&type=script&lang=ts"
import style0 from "./MedicalDateField.vue?vue&type=style&index=0&id=ec57af0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec57af0e",
  null
  
)

export default component.exports